import { Controller } from "@hotwired/stimulus"
import { React, StrictMode } from "react"
import { createRoot } from "react-dom/client"
import App from "../entrypoints/App"

export default class extends Controller {
  static values = { props: Object }

  connect() {
    this.root = createRoot(this.element)

    this.handler = this.handleReactEvent.bind(this)
    window.addEventListener("react:trigger", this.handler)

    this.root.render(
      <StrictMode>
        <App
          externalProps={this.propsValue}
         />
      </StrictMode>
    );
  }

  disconnect() {
    if (this.root) {
      this.root.unmount()
    }
  }

  handleReactEvent(event) {
    console.log("stimulus here, react is having an Event:", event.detail)
  }
}
